import React from 'react';


export default (props) => {
  return (
    <g {...props}>
      <path d="M36.00004,828.0001 L1260,828.0001 L1260,36.00002 L36.00004,36.00002 L36.00004,828.0001 L1260,828.0001 L1260,36.00002 L36.00004,36.00002 z" stroke="#000000" stroke-width="0.24" fill-opacity="0" />
    </g>

  )
}


// WEBPACK FOOTER //
// ./src/components/App/svg/layout_tabloid.js